import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type ModalSize = 'sm' | 'md' | 'lg' | 'xl';
export type ModalPosition = 'center' | 'top';
export type ModalAnimation = 'fade' | 'scale' | 'slide-right';

export interface ModalConfig {
  title: string;
  bodyTemplate: any;
  footerTemplate?: any;
  size?: ModalSize; 
  position?: ModalPosition;    
  animation?: ModalAnimation;   
  drawer?: boolean;  
  width?: string;
}

@Injectable({ providedIn: 'root' })

export class ModalService {
  private modalSubject = new BehaviorSubject<ModalConfig | null>(null);
  modal$ = this.modalSubject.asObservable();

  open(config: ModalConfig) {
    this.modalSubject.next(config);
  }

  close() {
    this.modalSubject.next(null);
  }
}
